import FanPaymentPopUp from "./FanPaymentPopUp";

export default FanPaymentPopUp;
